export const SET_BUSINESS_EXCELS = 'SET_BUSINESS_EXCELS';
export const DELETE_CHART = 'DELETE_CHART';